module.exports = __webpack_public_path__ + "static/media/hero_image.843f36a1.jpeg";